import * as service from './service'
import { HTTP_CODE } from '@/utils/request'
import { getRuleInfo } from './service'

export default {
  namespace: 'shansongValueRuleInfo',
  state: {
    demoData: {}
  },
  effects: {
    * getRuleInfo ({ payload }, { call, put }) {
      const res = yield call(service.getRuleInfo, payload)
      //   if (res.data.status !== HTTP_CODE.success) {
      //     throw new Error(res.data.err)
      //   }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
